import { MoneyInput } from "./MoneyInput";
import s from "./presupuesto.module.css";

const TIPO_COLOR = { INGRESO: "#22c55e", GASTO: "#f59e0b" };
const SUB_COLOR = "#3b82f6";
const MESES = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

// Semáforo del presupuesto contra lo real (al mes de corte).
const ESTADOS = {
  OK:       { cls: s.ok,       icon: "fa-circle-check",          label: "OK" },
  CERCA:    { cls: s.cerca,    icon: "fa-triangle-exclamation",  label: "Cerca del límite" },
  EXCEDIDO: { cls: s.excedido, icon: "fa-circle-xmark",          label: "Excedido" },
};
export const LEYENDA_ESTADOS = ESTADOS;

const fmt = (v) => Number(v).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

/** Fila de encabezado: Categoría · Ene … Dic · Total. */
export function PresupuestoHead({ mesCorte, meses }) {
  return (
    <div className={`${s.row} ${s.head}`}>
      <div className={`${s.cell} ${s.cat}`}>Categoría</div>
      {MESES.map((m) => (
        <div key={m} className={`${s.cell} ${m === mesCorte ? s.corte : ""}`}
          title={m === mesCorte ? "Mes de corte (se compara contra lo real)" : undefined}>
          {meses[m - 1].slice(0, 3)}
        </div>
      ))}
      <div className={`${s.cell} ${s.total}`}>Total</div>
    </div>
  );
}

export function PresupuestoNode({
  node, depth = 0, expandedIds, onToggle, edits, onEditMonth, calcularTotal, calcularMes, conReal, mesCorte,
}) {
  const expanded = expandedIds.has(node.id);
  const tieneHijos = node.subcuentas?.length > 0;
  const color = depth === 0 ? (TIPO_COLOR[node.tipo] || TIPO_COLOR.INGRESO) : SUB_COLOR;
  const estado = conReal ? ESTADOS[node.alerta] : null;
  const nivel = depth === 0 ? s.raiz : depth === 1 ? s.nivel1 : "";

  return (
    <>
      <div className={`${s.row} ${nivel}`}>
        <div className={`${s.cell} ${s.cat}`} style={{ paddingLeft: 10 + depth * 18 }}>
          <button type="button" className={s.toggle} onClick={() => onToggle(node.id)} disabled={!tieneHijos}
            aria-label={expanded ? "Contraer" : "Expandir"}>
            <i className={`fa-solid fa-chevron-${expanded ? "down" : "right"}`} />
          </button>
          <span className={s.dot} style={{ background: color, opacity: node.is_detalle || depth === 0 ? 1 : 0.75 }} />
          <span className={s.codigo}>{node.codigo}</span>
          <span className={s.nombre} title={node.nombre}>{node.nombre}</span>
        </div>

        {MESES.map((m) => (
          <div key={m} className={`${s.cell} ${m === mesCorte ? s.corte : ""}`}>
            {tieneHijos ? (
              // Cuenta con subcuentas: subtotal automático (lo propio + su subárbol).
              <span title="Subtotal automático (suma de las subcuentas)">{fmt(calcularMes(node, m))}</span>
            ) : (
              <MoneyInput className={s.input}
                value={edits[`${node.id}-${m}`] ?? "0"}
                onChange={(v) => onEditMonth(node.id, m, v)} />
            )}
          </div>
        ))}

        <div className={`${s.cell} ${s.total}`}>
          {estado && <i className={`fa-solid ${estado.icon} ${s.estado} ${estado.cls}`} title={estado.label} />}
          {fmt(calcularTotal(node))}
        </div>
      </div>

      {expanded && node.subcuentas?.map((sub) => (
        <PresupuestoNode
          key={sub.id} node={sub} depth={depth + 1}
          expandedIds={expandedIds} onToggle={onToggle}
          edits={edits} onEditMonth={onEditMonth}
          calcularTotal={calcularTotal} calcularMes={calcularMes} conReal={conReal} mesCorte={mesCorte}
        />
      ))}
    </>
  );
}
